module.exports = __webpack_public_path__ + "static/media/menu.cc546162.png";